import { Box, IconButton, Img } from '@chakra-ui/react';
import { TweetContext } from 'context/tweetContext';
import * as React from 'react';
import { AiOutlineDelete } from 'react-icons/ai';
import { colors } from 'theme/colors/colors';
import { hslToHsla } from 'utils/helpers';

export interface ISmallTweetPreviewProps {
  tweet: any;
  colorMode: string;
  handleDeletePost: (tweet: any) => void;
  userImage: string;
  twUserName: string;
}

export function SmallTweetPreview({ handleDeletePost, colorMode, tweet, userImage, twUserName }: ISmallTweetPreviewProps) {
  const tweetContext: any = React.useContext(TweetContext);
  const openPost = (tweet) => {
    if (tweet?.text) {
      tweetContext.setSelectedTweetPreview(tweet);
      tweetContext.onOpenTweetPreview();
    }
  }

  const deleteCustomPost = async (e, tweet) => {
    e.stopPropagation();
    handleDeletePost(tweet);
  }

  return (
    <Box
      key={tweet.id}
      as="button"
      textAlign="left"
      display="flex"
      position={"relative"}
      bgColor={"transparent"}
      rounded="md"
      borderWidth={1}
      transition="all 0.15s ease-in-out"
      shadow="sm"
      gap={3}
      alignItems="center"
      fontSize={"sm"}
      p={6}
      _hover={{
        backgroundColor: colorMode === "dark" ? hslToHsla(colors.primary.darkMode[105], 0.3) : hslToHsla(colors.primary.lightMode.default, 0.2),
      }}
      onClick={async (e) => {
        openPost(tweet);
      }}
    >
      <Img
        rounded="full"
        src={userImage}
        w={8}
        h={8}
        alt=""
      />
      <Box w="full" overflow="hidden">
        <Box
          display="flex"
          gap={4}
          fontSize="sm"
          whiteSpace="nowrap"
          overflow="hidden"
        >
          <Box
            as="span"
            fontWeight="semibold"
            dangerouslySetInnerHTML={{ __html: twUserName }}
            sx={{
              "& div": { display: "inline-block" },
              "& a": { color: "blue.600" },
              "& img[src*='emoji']": {
                width: "1.2em",
                height: "1.2em",
                marginRight: "0.075em",
                marginLeft: "0.075em",
                verticalAlign: "-20%",
                display: "inline-block",
              },
              "& svg[data-testid='icon-verified'] ": {
                display: "none",
              },
            }}
          />
        </Box>

        <Box
          w="full"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          sx={{
            "& div": { display: "inline-block" },
            "& a": { color: "blue.600" },
            "& img[src*='emoji']": {
              width: "1.2em",
              height: "1.2em",
              marginRight: "0.075em",
              marginLeft: "0.075em",
              verticalAlign: "-20%",
              display: "inline-block",
            },
          }}
          dangerouslySetInnerHTML={{ __html: tweet.text }}
        />
      </Box>
      <IconButton
        position={"absolute"}
        right={2}
        top={2}
        aria-label="watcher setting"
        icon={<AiOutlineDelete />}
        variant="tertiary"
        colorScheme="twitter"
        onClick={async (e) => await deleteCustomPost(e, tweet)}
        background={"none"}
        sx={{
          _hover: {
            "svg ": {
              color: colorMode === "dark" ? colors.alert.lightMode.default : colors.alert.darkMode.default
            },
          }
        }}
      />
    </Box>
  );
}
